module.exports = __webpack_public_path__ + "static/img/checkbox.33950d05.svg";